import axios from '../../axios';
import * as types from '../actionTypes';

const fetchBestPracticesRequest = () => ({type: types.FETCH_BEST_PRACTICES_REQUEST});
const fetchBestPracticesSuccess = bestPractices => ({type: types.FETCH_BEST_PRACTICES_SUCCESS, bestPractices});
const fetchBestPracticesFailure = error => ({type: types.FETCH_BEST_PRACTICES_FAILURE, error});

export const fetchBestPractices = query => {
  return dispatch => {
    dispatch(fetchBestPracticesRequest());
    return axios.get(`/api/list/practics${query|| ''}`).then(
      response => {
        dispatch(fetchBestPracticesSuccess(response.data));
      },
      error => {
        dispatch(fetchBestPracticesFailure(error));
      }
    )
  }
};

const fetchBestPracticeRequest = () => ({type: types.FETCH_BEST_PRACTICE_REQUEST});
const fetchBestPracticeSuccess = bestPractice => ({type: types.FETCH_BEST_PRACTICE_SUCCESS, bestPractice});
const fetchBestPracticeFailure = error => ({type: types.FETCH_BEST_PRACTICE_FAILURE, error});

export const fetchBestPractice = query => {
  return dispatch => {
    dispatch(fetchBestPracticeRequest());
    return axios.get(`/api/list/practics${query || ''}`).then(
      response => {
        dispatch(fetchBestPracticeSuccess(response.data));
      },
      error => {
        dispatch(fetchBestPracticeFailure(error));
      }
    )
  }
};

const createUserPracticeRequest = () => ({type: types.CREATE_USER_PRACTICE_REQUEST});
const createUserPracticeSuccess = (userBestPractice, id) => ({type: types.CREATE_USER_PRACTICE_SUCCESS, userBestPractice, id});
const createUserPracticeFailure = error => ({type: types.CREATE_USER_PRACTICE_SUCCESS, error});

export const createUserPractice = data => {
  return dispatch => {
    dispatch(createUserPracticeRequest());
    return axios.post('/api/private/practice', data).then(
      response => {
        dispatch(createUserPracticeSuccess(response.data, response.data.data.id));
      },
      error => {
        dispatch(createUserPracticeFailure(error));
      }
    )
  }
};

const fetchUserPracticesRequest = () => ({type: types.FETCH_USER_PRACTICES_REQUEST});
const fetchUserPracticesSuccess = userBestPractices => ({type: types.FETCH_USER_PRACTICES_SUCCESS, userBestPractices});
const fetchUserPracticesFailure = error => ({type: types.FETCH_USER_PRACTICES_FAILURE, error});

export const fetchUserPractices = query => {
  return dispatch => {
    dispatch(fetchUserPracticesRequest());
    return axios.get(`/api/private/practice${query || ''}`).then(
      response => {
        dispatch(fetchUserPracticesSuccess(response.data));
      },
      error => {
        dispatch(fetchUserPracticesFailure(error));
      }
    )
  }
};